export default {"src":"/_next/static/media/black-entry-point.0e61a09f.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};